export enum X_CART_TYPE {
    MRO = "mro",
    AIP = "aip",
}
